import { buildSearchForm } from "@magicware/forms/builder/searchForm";
import { SearchForm } from "@magicware/forms/components/Form";
import FormGrid from "@magicware/forms/components/FormGrid";
import FormTextField from "@magicware/forms/mui/FormTextField";
import { useTranslation } from "react-i18next";
import { libraryThunks } from "../../redux/libraries/librariesReducer";
import { RootState } from "../../redux/types";

const { f, useSearchForm } = buildSearchForm(
    libraryThunks.loadList,
    (state: RootState) => state.libraries.list?.filter,
    () => ({}),
);

export default function LibrarySearchForm() {
    const { t } = useTranslation();
    const searchForm = useSearchForm();
    return (
        <SearchForm {...searchForm}>
            <FormGrid tw="md:grid-cols-2">
                <FormTextField f={f} field="name" label={t("name-label")} searchIcon />
            </FormGrid>
        </SearchForm>
    );
}
